import { createFileRoute } from "@tanstack/react-router";
import Page from "@/app/admin/add-client/[id]/licenses/page";

export const Route = createFileRoute("/admin/add-client/$clientId/licenses")({
  component: Page,
});
